import { router } from '@inertiajs/react'
import axios from 'axios'
import { STATE } from 'lib/constants/api'
import { getDataFromLS, setDataToLS } from 'lib/utils/localStorage'
import { create } from 'zustand/react'
import { immer } from 'zustand/middleware/immer'

export type TOrderable = {
  quantity: number
  product: Data.Product
}

type TCartState = {
  isOpen: boolean
  orderables: TOrderable[]
  loadingState: STATE
}

type TCartActions = {
  setLoadingState: (loadingState: STATE) => void
  setIsOpen: (isOpen: boolean) => void
  addProduct: (product: Data.Product) => void
  toggleProduct: (product: Data.Product) => void
  removeProduct: (product: Data.Product) => void
  persistProducts: () => void
}

const LS_KEY = 'cart_orderables'

const useShoppingCartController = create<TCartState & TCartActions>()(
  immer((set, get) => ({
    isOpen: false,
    setIsOpen: (isOpen) => set(() => ({ isOpen })),
    orderables: getDataFromLS(LS_KEY) ?? [],
    loadingState: STATE.IDLE,
    addProduct: (product) => {
      const existedItemIndex = get().orderables.findIndex((item) => item.product.id === product.id)

      if (existedItemIndex !== -1) {
        set((state) => {
          state.orderables[existedItemIndex].quantity = state.orderables[existedItemIndex].quantity + 1
        })
      } else {
        const orderables = [...get().orderables, { quantity: 1, product }]

        set(() => ({
          orderables,
        }))
      }
      get().persistProducts()
    },
    toggleProduct: (product) => {
      // const existedProduct = get().products.find((item) => item.id === product.id)
      // if (existedProduct) {
      //   get().removeProduct(product)
      // } else get().addProduct(product)
    },
    removeProduct: (product) => {
      const existedItemIndex = get().orderables.findIndex((item) => item.product.id === product.id)
      if (existedItemIndex !== -1) {
        if (get().orderables[existedItemIndex].quantity > 1) {
          set((state) => {
            state.orderables[existedItemIndex].quantity = state.orderables[existedItemIndex].quantity - 1
          })
        } else {
          const orderables = get().orderables.filter((item) => item.product.id !== product.id)

          set(() => ({ orderables, isOpen: orderables.length > 0 }))
        }
      }
      get().persistProducts()
    },
    setLoadingState: (loadingState) =>
      set((state) => {
        state.loadingState = loadingState
      }),
    persistProducts: () => {
      setDataToLS(LS_KEY, get().orderables)
    },
  })),
)

export { useShoppingCartController }
